import "./Policies.module.css";
import Header from "@/reusable_sections/Header";
import Policies from "./sections/Policies";
import Footer from "@/reusable_sections/Footer";
export default function PoliciesPage() {
  return <div>
      <Header />
      <Policies />
      <Footer />
    </div>;
}